export default __webpack_public_path__ + "static/media/THAISRI.caf2eff5.png";